import { n as serializeError, t as createLogger } from "./app.shared-CmP4XLF_.js";

import { a as getAllLockers, i as escapeAttributeValue, n as initModalOrchestrator, o as getLockerContainer, r as captureFocusKey, s as isFocusable } from "./app.shared-CsqTb1qy.js";

import { t as debounce } from "./app.shared-OQDvbu1B.js";

import { t as withTimeout } from "./app.shared-CBZA3IJ4.js";

import { t as formatMoney } from "./app.shared-DrMetWk9.js";

import { t as getSizedImage } from "./app.shared-B26xt0vM.js";

import { t as initBis } from "./app.shared-CJnrkVha.js";

var log$4 = createLogger("locker-spinner-positioning");

var DESKTOP_BREAKPOINT = "(min-width: 1024px)";

var PAD_PX = 16;

var SOURCES = Object.freeze({
    quickShop: "locker:quick-shop",
    outOfStock: "locker:out-of-stock",
    cart: "locker:cart"
});

var initialised$3 = false;

var bottomSheetEdgeY = rect => Math.round(window.innerHeight - rect.height);

var initLoadingSpinnerPositioning = () => {
    if (initialised$3) return;
    initialised$3 = true;
    const isDesktop = () => window.matchMedia(DESKTOP_BREAKPOINT).matches;
    const lastNudges = new Map;
    const dispatchNudge = (lane, source, transform, extra = {}) => {
        const detail = {
            lane: lane,
            source: source,
            transform: transform,
            ...extra
        };
        lastNudges.set(source, detail);
        log$4("ui", "dispatch global-ui:nudge", detail);
        document.dispatchEvent(new CustomEvent("global-ui:nudge", {
            detail: detail
        }));
    };
    const clearSource = (source, fallbackLane) => {
        const lane = lastNudges.get(source)?.lane ?? fallbackLane;
        dispatchNudge(lane, source, "", lane === "bottom" ? {
            edgeY: null,
            exclusive: true
        } : {});
    };
    document.addEventListener("global-ui:nudge-request", event => {
        const {lane: lane} = event.detail ?? {};
        lastNudges.forEach(cached => {
            if (lane !== cached.lane && lane !== "all") return;
            document.dispatchEvent(new CustomEvent("global-ui:nudge", {
                detail: cached
            }));
        });
    });
    const measureDrawer = lockerId => {
        const drawer = getLockerContainer(lockerId)?.querySelector("[data-drawer]");
        const rect = drawer?.getBoundingClientRect() ?? null;
        if (!drawer || !rect) {
            log$4("errors", "measureDrawer: drawer/rect missing", {
                lockerId: lockerId
            });
            return null;
        }
        const cssTransform = getComputedStyle(drawer).transform;
        log$4("ui", "measureDrawer", {
            lockerId: lockerId,
            width: Math.round(rect.width),
            height: Math.round(rect.height),
            top: Math.round(rect.top),
            right: Math.round(rect.right),
            bottom: Math.round(rect.bottom),
            left: Math.round(rect.left),
            viewportH: window.innerHeight,
            cssTransform: cssTransform === "none" ? "none" : cssTransform
        });
        return rect;
    };
    const onOpened = event => {
        const {lockerId: lockerId} = event.detail ?? {};
        if (!lockerId) return;
        log$4("lifecycle", "locker:opened", {
            lockerId: lockerId,
            isDesktop: isDesktop()
        });
        if (lockerId.endsWith("-quick-shop")) {
            const rect = measureDrawer(lockerId);
            if (!rect) return;
            if (isDesktop()) dispatchNudge("bottom-right", SOURCES.quickShop, `translateX(-${Math.round(rect.width) + PAD_PX}px)`); else dispatchNudge("bottom", SOURCES.quickShop, `translateY(-${Math.round(rect.height) + PAD_PX}px)`, {
                edgeY: bottomSheetEdgeY(rect),
                exclusive: true
            });
            return;
        }
        if (lockerId === "Cart") {
            if (!isDesktop()) return;
            const rect = measureDrawer(lockerId);
            if (!rect) return;
            dispatchNudge("bottom-right", SOURCES.cart, `translateX(-${Math.round(rect.width) + PAD_PX}px)`);
            return;
        }
        if (lockerId.endsWith("-out-of-stock")) {
            if (isDesktop()) {
                dispatchNudge("bottom-right", SOURCES.outOfStock, "RESET");
                return;
            }
            const rect = measureDrawer(lockerId);
            if (!rect) return;
            dispatchNudge("bottom", SOURCES.outOfStock, `translateY(-${Math.round(rect.height) + PAD_PX}px)`, {
                edgeY: bottomSheetEdgeY(rect),
                exclusive: true
            });
        }
    };
    const onClosed = event => {
        const {lockerId: lockerId} = event.detail ?? {};
        if (!lockerId) return;
        log$4("lifecycle", "locker:closed", {
            lockerId: lockerId
        });
        if (lockerId.endsWith("-quick-shop")) clearSource(SOURCES.quickShop, isDesktop() ? "bottom-right" : "bottom"); else if (lockerId.endsWith("-out-of-stock")) clearSource(SOURCES.outOfStock, isDesktop() ? "bottom-right" : "bottom"); else if (lockerId === "Cart") clearSource(SOURCES.cart, "bottom-right");
    };
    window.addEventListener("locker:opened", onOpened);
    window.addEventListener("locker:closed", onClosed);
};

var log$3 = createLogger("app-widgets");

var NUDGE_EVENT = "global-ui:nudge";

var NUDGE_REQUEST_EVENT = "global-ui:nudge-request";

var STACK_CHANGED_EVENT = "locker:stack-changed";

var GAP_PX = 12;

var FULL_VIEWPORT_RATIO = .95;

var WIDGETS = [ {
    id: "census",
    selector: "#census-onsite-widget",
    lane: "bottom-left",
    baseZ: 60,
    ownsTransform: false
} ];

var controllers = new Map;

var pendingEntries = new Set;

var adoptionObserver = null;

var initialised$2 = false;

var acceptsLane = (entry, lane) => lane === entry.lane || lane === "bottom" || lane === "all";

var requestLanesFor = entry => [ ...new Set([ entry.lane, "bottom", "all" ]) ];

var computedTranslateY = el => {
    const transform = getComputedStyle(el).transform;
    if (!transform || transform === "none") return 0;
    const values = transform.match(/-?[\d.]+/g);
    if (!values) return 0;
    return transform.startsWith("matrix3d") ? Number(values[13]) || 0 : Number(values[5]) || 0;
};

var sumTranslateY = value => {
    let total = 0;
    for (const match of (value || "").matchAll(/translateY\((-?[\d.]+)px\)/g)) total += Math.abs(Number(match[1]));
    return total;
};

var measureRestingBottom = el => {
    const rect = el.getBoundingClientRect();
    const y = computedTranslateY(el);
    return rect.bottom - y;
};

var normaliseCandidate = (ctrl, detail) => {
    const {edgeY: edgeY, transform: transform, isSibling: isSibling = false, exclusive: exclusive = false} = detail;
    if (edgeY === null) return null;
    if (edgeY !== void 0) {
        const parsed = Number(edgeY);
        if (!Number.isFinite(parsed)) return null;
        return {
            kind: exclusive ? "modal-cover" : "push-above",
            edgeY: parsed
        };
    }
    if (transform === void 0) return null;
    if (transform === "" || transform === null || transform === "none" || transform === "RESET") return null;
    const y = sumTranslateY(transform);
    if (y <= 0) return null;
    const restingBottom = ctrl.restingBottom ?? measureRestingBottom(ctrl.el);
    ctrl.restingBottom = restingBottom;
    return {
        kind: isSibling ? "push-above" : "modal-cover",
        edgeY: restingBottom + GAP_PX - y
    };
};

var stackHasFullViewportLocker = stackIds => stackIds.some(lockerId => {
    const container = getLockerContainer(lockerId);
    if (!container) return false;
    const rect = (container.querySelector("[data-drawer]") || container).getBoundingClientRect();
    return rect.width >= FULL_VIEWPORT_RATIO * window.innerWidth && rect.height >= FULL_VIEWPORT_RATIO * window.innerHeight;
});

var applyStackZ = (ctrl, stackIds) => {
    if (!ctrl.el) return;
    ctrl.el.style.zIndex = stackHasFullViewportLocker(stackIds) ? String(ctrl.entry.baseZ) : "";
};

var renderTransform = ctrl => {
    if (ctrl.entry.ownsTransform) return;
    const candidates = [ ...ctrl.candidates.values() ];
    const covers = candidates.filter(candidate => candidate.kind === "modal-cover");
    const pushes = candidates.filter(candidate => candidate.kind === "push-above");
    const active = covers.length ? covers : pushes;
    if (!active.length) {
        if (ctrl.lastTransform !== "none") {
            ctrl.lastTransform = "none";
            ctrl.el.style.setProperty("--app-widget-transform", "none");
        }
        return;
    }
    const restingBottom = ctrl.restingBottom ?? measureRestingBottom(ctrl.el);
    ctrl.restingBottom = restingBottom;
    const targetEdge = Math.min(...active.map(candidate => candidate.edgeY));
    const offsetY = Math.max(0, Math.round(restingBottom + GAP_PX - targetEdge));
    const transform = offsetY > 0 ? `translateY(-${offsetY}px)` : "none";
    if (transform === ctrl.lastTransform) return;
    ctrl.lastTransform = transform;
    ctrl.el.style.setProperty("--app-widget-transform", transform);
};

var scheduleRender = ctrl => {
    if (ctrl.renderRaf !== null) return;
    ctrl.renderRaf = requestAnimationFrame(() => {
        ctrl.renderRaf = null;
        renderTransform(ctrl);
    });
};

var handleNudge = event => {
    const detail = event.detail ?? {};
    const {lane: lane, source: source = "default", transform: transform} = detail;
    if (!lane) return;
    if (transform === void 0 && detail.edgeY === void 0) return;
    controllers.forEach(ctrl => {
        if (!acceptsLane(ctrl.entry, lane)) return;
        const candidate = normaliseCandidate(ctrl, detail);
        if (!candidate) ctrl.candidates.delete(source); else ctrl.candidates.set(source, candidate);
        scheduleRender(ctrl);
    });
};

var handleStackChanged = event => {
    const stackIds = event.detail?.stack ?? [];
    controllers.forEach(ctrl => applyStackZ(ctrl, stackIds));
};

var bindController = (entry, el) => {
    el.setAttribute("data-app-widget", "");
    el.setAttribute("data-app-widget-id", entry.id);
    if (entry.ownsTransform) el.setAttribute("data-app-widget-notransform", "");
    const ctrl = {
        entry: entry,
        el: el,
        candidates: new Map,
        restingBottom: null,
        lastTransform: "none",
        renderRaf: null,
        resizeObserver: null,
        removalObserver: null
    };
    controllers.set(entry.id, ctrl);
    const parent = el.parentNode;
    if (parent) {
        ctrl.removalObserver = new MutationObserver(() => {
            if (el.isConnected) return;
            if (ctrl.renderRaf !== null) cancelAnimationFrame(ctrl.renderRaf);
            ctrl.renderRaf = null;
            ctrl.resizeObserver?.disconnect();
            ctrl.resizeObserver = null;
            ctrl.removalObserver?.disconnect();
            ctrl.removalObserver = null;
            controllers.delete(entry.id);
            pendingEntries.add(entry);
            ensureAdoptionObserver();
        });
        ctrl.removalObserver.observe(parent, {
            childList: true
        });
    }
    ctrl.restingBottom = measureRestingBottom(el);
    ctrl.resizeObserver = new ResizeObserver(() => {
        ctrl.restingBottom = null;
        scheduleRender(ctrl);
    });
    ctrl.resizeObserver.observe(el);
    const stackIds = window.LockerManager?.getStackSnapshot?.() ?? [];
    applyStackZ(ctrl, stackIds);
    requestLanesFor(entry).forEach(lane => {
        document.dispatchEvent(new CustomEvent(NUDGE_REQUEST_EVENT, {
            detail: {
                lane: lane
            }
        }));
    });
    log$3("lifecycle", "app widget adopted", {
        id: entry.id,
        lane: entry.lane,
        stackIds: stackIds
    });
};

var adoptEntry = entry => {
    const el = document.querySelector(entry.selector);
    if (!el) return false;
    bindController(entry, el);
    return true;
};

var ensureAdoptionObserver = () => {
    if (adoptionObserver || pendingEntries.size === 0) return;
    adoptionObserver = new MutationObserver(() => {
        pendingEntries.forEach(entry => {
            if (adoptEntry(entry)) pendingEntries.delete(entry);
        });
        if (pendingEntries.size === 0) {
            adoptionObserver.disconnect();
            adoptionObserver = null;
            log$3("lifecycle", "adoption observer disconnected — all widgets bound");
        }
    });
    adoptionObserver.observe(document.body, {
        childList: true,
        subtree: true
    });
};

var initAppWidgets = () => {
    if (initialised$2) return;
    initialised$2 = true;
    document.addEventListener(NUDGE_EVENT, handleNudge);
    window.addEventListener(STACK_CHANGED_EVENT, handleStackChanged);
    window.addEventListener("resize", debounce(() => {
        controllers.forEach(ctrl => {
            ctrl.restingBottom = null;
            scheduleRender(ctrl);
        });
    }, 150), {
        passive: true
    });
    WIDGETS.forEach(entry => {
        if (!adoptEntry(entry)) pendingEntries.add(entry);
    });
    ensureAdoptionObserver();
    log$3("lifecycle", "app-widgets manager initialized", {
        registered: WIDGETS.length,
        pending: pendingEntries.size
    });
};

var log$2 = createLogger("cart-core");

var REQUEST_TIMEOUT_MS = 8e3;

var CartCore = class {
    constructor() {
        this._queue = [];
        this._processing = false;
    }
    add(input, opts = {}) {
        const controller = new AbortController;
        if (opts.signal) opts.signal.addEventListener("abort", () => controller.abort(), {
            once: true
        });
        const signal = controller.signal;
        const form = input instanceof HTMLFormElement ? input : null;
        const data = form ? this._parseForm(form) : input;
        this._dispatch(document, "cart:loading", {
            loading: true,
            form: form,
            action: "add"
        });
        return this._enqueue(`${window.Shopify.routes.root}cart/add.js`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data),
            signal: signal
        }).then(async lineItem => {
            const json = form?.querySelector('[type="application/json"]');
            let product = null;
            if (json) {
                product = JSON.parse(json.textContent);
                if (!product.url) product.url = `https://${location.host}/products/${product.handle}`;
            }
            const cart = await this.get();
            this._dispatch(document, "cart:added", {
                item: lineItem,
                cart: cart,
                product: product,
                form: form
            });
            this._dispatch(document, "cart:updated", {
                cart: cart
            });
            this._dispatch(document, "cart:loading", {
                loading: false,
                form: form,
                action: "add"
            });
            opts.callback?.(null, cart);
            return cart;
        }).catch(err => {
            if (err.name === "AbortError") {
                log$2("network", "add aborted");
                return;
            }
            this._dispatch(document, "cart:error", {
                error: err,
                message: err.description || err.message,
                form: form,
                action: "add"
            });
            this._dispatch(document, "cart:loading", {
                loading: false,
                form: form,
                action: "add"
            });
            opts.callback?.(err, null);
            throw err;
        });
    }
    change(data, opts = {}) {
        this._dispatch(document, "cart:loading", {
            loading: true,
            form: null,
            action: "change"
        });
        return this._enqueue(`${window.Shopify.routes.root}cart/change.js`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data)
        }).then(cart => {
            this._dispatch(document, "cart:updated", {
                cart: cart
            });
            this._dispatch(document, "cart:loading", {
                loading: false,
                form: null,
                action: "change"
            });
            opts.callback?.(null, cart);
            return cart;
        }).catch(err => {
            this._dispatch(document, "cart:error", {
                error: err,
                message: err.description || err.message,
                form: null,
                action: "change"
            });
            this._dispatch(document, "cart:loading", {
                loading: false,
                form: null,
                action: "change"
            });
            opts.callback?.(err, null);
            throw err;
        });
    }
    update(data, opts = {}) {
        this._dispatch(document, "cart:loading", {
            loading: true,
            form: null,
            action: "update"
        });
        return this._enqueue(`${window.Shopify.routes.root}cart/update.js`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data)
        }).then(cart => {
            this._dispatch(document, "cart:updated", {
                cart: cart
            });
            this._dispatch(document, "cart:loading", {
                loading: false,
                form: null,
                action: "update"
            });
            opts.callback?.(null, cart);
            return cart;
        }).catch(err => {
            this._dispatch(document, "cart:error", {
                error: err,
                message: err.description || err.message,
                form: null,
                action: "update"
            });
            this._dispatch(document, "cart:loading", {
                loading: false,
                form: null,
                action: "update"
            });
            opts.callback?.(err, null);
            throw err;
        });
    }
    get(opts = {}) {
        return this._enqueue(`${window.Shopify.routes.root}cart.js`, {
            method: "GET",
            headers: {
                Accept: "application/json"
            },
            signal: opts.signal
        });
    }
    _drainQueue() {
        const stub = window.MBF?.cart;
        const pending = stub?.queue || [];
        if (stub) stub.action = (method, ...args) => this[method]?.(...args);
        pending.forEach(({method: method, args: args}) => {
            if (typeof this[method] === "function") this[method](...args);
        });
    }
    _enqueue(url, fetchOpts) {
        const fp = `${fetchOpts.method}:${url}:${fetchOpts.body ?? ""}`;
        if (!url.includes("cart/add.js") && this._queue.some(t => t.fp === fp)) {
            log$2("network", "duplicate request dropped", {
                request: fp
            });
            const error = new Error("[cart] Duplicate request dropped");
            error.duplicate = true;
            return Promise.reject(error);
        }
        return new Promise((resolve, reject) => {
            this._queue.push({
                fp: fp,
                run: () => {
                    const {signal: signal, cancel: cancel} = withTimeout(fetchOpts.signal, REQUEST_TIMEOUT_MS);
                    return fetch(url, {
                        ...fetchOpts,
                        signal: signal
                    }).finally(cancel).then(async res => {
                        if (!res.ok) {
                            const err = await res.json().catch(() => null);
                            const description = err?.description;
                            const message = typeof description === "string" && description || typeof err?.message === "string" && err.message || `HTTP ${res.status}`;
                            const errors = err?.errors || (description && typeof description === "object" ? description : null);
                            const error = new Error(message);
                            error.status = res.status;
                            error.description = description;
                            error.errors = errors;
                            error.payload = err;
                            throw error;
                        }
                        log$2("network", "response ok", {
                            url: url,
                            status: res.status
                        });
                        return res.json();
                    });
                },
                resolve: resolve,
                reject: reject
            });
            log$2("network", "request queued", {
                request: fp,
                depth: this._queue.length
            });
            this._processQueue();
        });
    }
    async _processQueue() {
        if (this._processing || !this._queue.length) return;
        this._processing = true;
        while (this._queue.length) {
            const task = this._queue[0];
            try {
                task.resolve(await task.run());
            } catch (err) {
                log$2("errors", "request failed", {
                    request: task.fp,
                    error: err
                });
                task.reject(err);
            }
            this._queue.shift();
        }
        this._processing = false;
    }
    _parseForm(form) {
        const formData = new FormData(form);
        if (form.querySelector('[name="purchase_option"]:checked')?.value === "once") formData.delete("selling_plan");
        if (formData.get("properties[__shopify_send_gift_card_to_recipient]") === "false") formData.delete("properties[__shopify_send_gift_card_to_recipient]");
        const json = {};
        for (const [key, value] of formData.entries()) {
            const keys = key.split(/[\[\]]+/).filter(k => k);
            let current = json;
            for (let i = 0; i < keys.length; i++) {
                const k = keys[i];
                if (i === keys.length - 1) if (Object.prototype.hasOwnProperty.call(current, k)) if (Array.isArray(current[k])) current[k].push(value); else current[k] = [ current[k], value ]; else current[k] = value; else {
                    const nextKey = keys[i + 1];
                    if (!current[k]) current[k] = /^\d+$/.test(nextKey) ? [] : {};
                    current = current[k];
                }
            }
        }
        return json;
    }
    _dispatch(target, event, detail) {
        target.dispatchEvent(new CustomEvent(event, {
            bubbles: true,
            detail: detail
        }));
    }
};

var initialised$1 = false;

function initCartUI() {
    if (initialised$1) return;
    initialised$1 = true;
    let savedStates = new Map;
    let activeButtons = [];
    const pendingReverts = new Set;
    const transient = new WeakSet;
    function cancelRevert(buttons) {
        for (const entry of pendingReverts) if (!buttons || entry.buttons.some(b => buttons.includes(b))) {
            clearTimeout(entry.timer);
            pendingReverts.delete(entry);
        }
    }
    function scheduleRevert(buttons) {
        cancelRevert(buttons);
        const entry = {
            buttons: buttons,
            timer: 0
        };
        entry.timer = setTimeout(() => {
            pendingReverts.delete(entry);
            resetButtons(buttons);
        }, 2e3);
        pendingReverts.add(entry);
    }
    function findButtons(form) {
        return [ ...form?.querySelectorAll("[data-atc]") ?? [] ];
    }
    function snapshotButtons(buttons) {
        buttons.forEach(btn => {
            if (transient.has(btn)) return;
            savedStates.set(btn, {
                innerHTML: btn.innerHTML,
                disabled: btn.disabled
            });
        });
    }
    function setButtonText(btn, text) {
        const textEl = btn.querySelector("[data-atc-text]");
        if (textEl) {
            const children = Array.from(textEl.children);
            if (children.length) children.forEach(child => {
                child.textContent = text;
            }); else textEl.textContent = text;
        } else btn.innerHTML = text;
    }
    function resetButtons(buttons) {
        buttons.forEach(btn => {
            transient.delete(btn);
            const saved = savedStates.get(btn);
            if (saved) {
                btn.innerHTML = saved.innerHTML;
                btn.disabled = saved.disabled;
            } else {
                const textEl = btn.querySelector("[data-atc-text]");
                const fallbackText = window.MBF?.strings?.addToCart || "Translation missing: en.product.add_to_cart";
                if (textEl) {
                    const children = Array.from(textEl.children);
                    if (children.length) children.forEach(child => {
                        child.textContent = fallbackText;
                    }); else textEl.textContent = fallbackText;
                } else btn.innerHTML = fallbackText;
                btn.disabled = false;
            }
        });
    }
    function setFormLoading(form, loading) {
        if (!form) return;
        form.closest(".product-form")?.classList.toggle("loading", loading);
    }
    function handleNonAddLoading(loading) {
        document.dispatchEvent(new CustomEvent(loading ? "spinner:show" : "spinner:hide", {
            bubbles: true,
            detail: {
                source: "cart"
            }
        }));
    }
    const applyCount = cart => {
        const count = cart?.item_count;
        if (typeof count !== "number") return;
        document.querySelectorAll("[data-cart-count]").forEach(el => {
            el.textContent = count;
        });
    };
    let saving = false;
    document.addEventListener("cart:save-start", () => {
        saving = true;
    });
    document.addEventListener("cart:save-end", e => {
        saving = false;
        applyCount(e.detail?.cart);
    });
    document.addEventListener("cart-item:error", () => {
        saving = false;
    });
    document.addEventListener("cart:updated", e => {
        if (saving) return;
        applyCount(e.detail?.cart);
    });
    document.addEventListener("cart:loading", e => {
        const {loading: loading, form: form, action: action} = e.detail;
        if (action !== "add") {
            handleNonAddLoading(loading);
            return;
        }
        if (loading) {
            activeButtons = findButtons(form);
            cancelRevert(activeButtons);
            snapshotButtons(activeButtons);
            activeButtons.forEach(btn => {
                setButtonText(btn, window.MBF?.strings?.adding || "Translation missing: en.product.adding");
                btn.disabled = true;
            });
            document.dispatchEvent(new CustomEvent("spinner:show", {
                bubbles: true,
                detail: {
                    source: "cart"
                }
            }));
            setFormLoading(form, true);
        } else {
            document.dispatchEvent(new CustomEvent("spinner:hide", {
                bubbles: true,
                detail: {
                    source: "cart"
                }
            }));
            setFormLoading(form, false);
        }
    });
    window.addEventListener("cart:added", e => {
        const {form: form} = e.detail;
        const buttons = form ? findButtons(form) : activeButtons;
        if (!buttons.length) return;
        cancelRevert(buttons);
        buttons.forEach(btn => {
            setButtonText(btn, window.MBF?.strings?.added || "Translation missing: en.product.added");
            btn.disabled = true;
            transient.add(btn);
        });
        scheduleRevert(buttons);
    });
    document.addEventListener("cart:error", e => {
        const {form: form} = e.detail;
        const buttons = form ? findButtons(form) : activeButtons;
        if (!buttons.length) return;
        buttons.forEach(btn => {
            setButtonText(btn, window.MBF?.strings?.error || "Error");
            btn.disabled = true;
            transient.add(btn);
        });
        scheduleRevert(buttons);
    });
}

var initialised = false;

function initCartAnalytics() {
    if (initialised) return;
    initialised = true;
    window.addEventListener("cart:added", e => {
        const {item: item, product: product} = e.detail;
        if (!product) return;
        if (!window.Shopify?.customerPrivacy?.userCanBeTracked()) return;
        _trackKlaviyo(item, product);
        _trackGA4(item, product);
    });
}

function _trackKlaviyo(item, product) {
    try {
        const sizedImage = getSizedImage(product.featured_image, "1024x");
        window._learnq = window._learnq || [];
        window._learnq.push([ "track", "Added to Cart", {
            Name: product.title,
            Title: product.title,
            ItemId: product.id,
            ProductId: product.id,
            Price: product.price / 100,
            CompareAtPrice: product.compare_at_price_max / 100,
            Categories: "",
            ImageUrl: sizedImage || "",
            Url: product.url,
            Metadata: {
                Brand: product.vendor,
                Price: product.price / 100,
                CompareAtPrice: product.compare_at_price / 100
            }
        } ]);
    } catch (e) {
        console.warn("[cart] Klaviyo tracking failed", e);
    }
}

function _trackGA4(item, product) {
    try {
        const sizedImage = getSizedImage(product.featured_image, "1024x");
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "add_to_cart",
            ecommerce: {
                items: [ {
                    item_id: item?.sku || product.id,
                    item_variant: item?.variant_id || "",
                    item_name: product.title,
                    price: formatMoney(product.price),
                    item_brand: product.vendor,
                    item_category: product.type,
                    item_list_name: "",
                    description: "",
                    imageURL: sizedImage || "",
                    productURL: product.url
                } ]
            }
        });
    } catch (e) {
        console.warn("[cart] GA4 tracking failed", e);
    }
}

function initCart() {
    window.MBF = window.MBF || {};
    const cart = new CartCore;
    window.MBF.cart = cart;
    cart._drainQueue();
}

var log$1 = createLogger("body.js");

function handleButtonKeydown(event) {
    if (event.target.tagName === "LABEL") {
        log$1("events", "button-keydown skipped label", {
            for: event.target.htmlFor
        });
        return;
    }
    if (event.key !== "Enter" && event.key !== " ") return;
    event.preventDefault();
    const element = event.target;
    element.classList.add("active");
    setTimeout(() => {
        element.classList.remove("active");
    }, 150);
    element.click();
}

function initLabelKeyboardAccessibility() {
    document.addEventListener("keydown", event => {
        const activeElement = document.activeElement;
        if ((event.key === "Enter" || event.code === "Space") && activeElement.tagName === "LABEL" && activeElement.htmlFor) {
            const targetInput = document.getElementById(activeElement.htmlFor);
            if (targetInput && (targetInput.type === "checkbox" || targetInput.type === "radio")) {
                log$1("events", "label keydown", {
                    key: event.key,
                    for: activeElement.htmlFor,
                    checkedBefore: targetInput.checked
                });
                activeElement.click();
                log$1("events", "label activated", {
                    for: activeElement.htmlFor,
                    checkedAfter: targetInput.checked
                });
                event.preventDefault();
            }
        }
    });
    const makeLabelAccessible = label => {
        if (label.htmlFor && !label.hasAttribute("tabindex")) label.tabIndex = 0;
    };
    document.querySelectorAll("label[for]").forEach(makeLabelAccessible);
    new MutationObserver(mutations => {
        mutations.forEach(mutation => {
            mutation.addedNodes.forEach(node => {
                if (node.nodeType !== Node.ELEMENT_NODE) return;
                if (node.tagName === "LABEL" && node.htmlFor) makeLabelAccessible(node);
                node.querySelectorAll?.("label[for]").forEach(makeLabelAccessible);
            });
        });
    }).observe(document.body, {
        childList: true,
        subtree: true
    });
}

function initButtonRoleAccessibility() {
    const makeButtonAccessible = element => {
        if (!element.hasAttribute("tabindex")) element.tabIndex = 0;
        if (!element.hasAttribute("data-keyboard-enabled")) {
            element.addEventListener("keydown", handleButtonKeydown);
            element.setAttribute("data-keyboard-enabled", "true");
        }
    };
    document.querySelectorAll('[role="button"]').forEach(makeButtonAccessible);
    const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
            mutation.addedNodes.forEach(node => {
                if (node.nodeType !== Node.ELEMENT_NODE) return;
                if (node.getAttribute("role") === "button") makeButtonAccessible(node);
                node.querySelectorAll?.('[role="button"]').forEach(makeButtonAccessible);
            });
        });
    });
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    window._buttonRoleObserver = observer;
}

function exposeAccessibilityCleanup() {
    window._accessibilityCleanup = () => {
        if (window._buttonRoleObserver) {
            window._buttonRoleObserver.disconnect();
            delete window._buttonRoleObserver;
        }
    };
}

function checkLocation() {
    const geoPopupData = localStorage.getItem("GEO_POPUP_SHOWN");
    if (geoPopupData) try {
        const {timestamp: timestamp} = JSON.parse(geoPopupData);
        if (Date.now() - timestamp < 1800 * 1e3) return;
    } catch {}
    window.Geo.perform(country => {
        if (country.handle !== window.Shopify?.country) {
            const modal = document.getElementById("Modal-Localization")?.closest(".modal");
            const modalToggle = document.getElementById("Modal-Localization");
            const select = modal?.querySelector('[name="country_code"]');
            if (!select || !modal) return;
            select.value = country.handle;
            select.dispatchEvent(new Event("change", {
                bubbles: true
            }));
            if (!modalToggle.checked) modalToggle.click();
            document.body.classList.add("attentive-hide");
            localStorage.setItem("GEO_POPUP_SHOWN", JSON.stringify({
                timestamp: Date.now()
            }));
        }
    });
}

var ensureBaseUnderlay = (currentBaseUnderlayEl, baseUnderlayZIndex) => {
    if (currentBaseUnderlayEl?.isConnected) return currentBaseUnderlayEl;
    const existing = document.querySelector("[data-locker-base-underlay]");
    if (existing) return existing;
    const underlay = document.createElement("div");
    underlay.setAttribute("data-locker-base-underlay", "");
    underlay.className = "locker-base-underlay";
    underlay.style.zIndex = String(baseUnderlayZIndex);
    document.body.appendChild(underlay);
    return underlay;
};

var applyContainerStates = ({stackEntries: stackEntries, layerZIndexBase: layerZIndexBase, getLockerContainer: getLockerContainer}) => {
    const stackSize = stackEntries.length;
    const topEntry = stackEntries[stackSize - 1] || null;
    getAllLockers().forEach(locker => {
        if (!locker.id) return;
        const container = getLockerContainer(locker.id);
        if (!container) return;
        const stackIndex = stackEntries.findIndex(entry => entry.lockerId === locker.id);
        const isActive = stackIndex !== -1;
        const isTop = Boolean(topEntry && topEntry.lockerId === locker.id);
        container.dataset.layerActive = isActive ? "true" : "false";
        if (isActive) {
            delete container.dataset.layerExiting;
            container.dataset.layerTop = isTop ? "true" : "false";
            container.dataset.layerIndex = String(stackIndex);
            container.dataset.layerDepth = String(stackSize);
            container.dataset.layerOverlay = isTop ? "false" : "true";
            container.style.setProperty("--locker-layer-index", String(stackIndex));
            container.style.zIndex = String(layerZIndexBase + stackIndex * 2);
        } else {
            delete container.dataset.layerTop;
            delete container.dataset.layerIndex;
            delete container.dataset.layerDepth;
            delete container.dataset.layerOverlay;
            container.style.removeProperty("--locker-layer-index");
            if (container.style.zIndex) container.dataset.layerExiting = "true";
        }
        container.toggleAttribute("inert", !isTop);
    });
};

var isHeaderElement = (element, headerSelector) => Boolean(element.matches && (element.matches(headerSelector) || element.closest && element.closest(headerSelector)));

var getFilteredElements = ({elements: elements, lockerContainer: lockerContainer, mainElement: mainElement, sectionSelector: sectionSelector, headerSelector: headerSelector, shouldIncludeHeaders: shouldIncludeHeaders}) => {
    const isLockerInsideMain = mainElement.contains(lockerContainer);
    let elementsToManage = Array.from(elements).filter(element => {
        if (isHeaderElement(element, headerSelector)) return shouldIncludeHeaders;
        if (!isLockerInsideMain) return element === mainElement || !mainElement.contains(element) && !element.contains(lockerContainer);
        if (element === mainElement) return false;
        return !element.contains(lockerContainer);
    });
    const parentElement = lockerContainer.closest(sectionSelector);
    if (parentElement) {
        const sectionChildren = Array.from(parentElement.children);
        if (sectionChildren.includes(lockerContainer)) {
            const siblings = sectionChildren.filter(child => child !== lockerContainer && (!isHeaderElement(child, headerSelector) || shouldIncludeHeaders) && !child.contains(lockerContainer) && child.tagName !== "SCRIPT" && child.tagName !== "STYLE");
            const combined = new Set([ ...elementsToManage, ...siblings ]);
            elementsToManage = Array.from(combined);
        } else {
            let current = lockerContainer;
            const walkedSiblings = new Set;
            while (current && current !== parentElement) {
                const ancestor = current.parentElement;
                if (!ancestor) break;
                Array.from(ancestor.children).forEach(sibling => {
                    if (sibling === current || sibling.tagName === "SCRIPT" || sibling.tagName === "STYLE" || sibling.tagName === "INPUT" && sibling.hidden || sibling.contains(lockerContainer)) return;
                    walkedSiblings.add(sibling);
                });
                current = ancestor;
            }
            const combined = new Set([ ...elementsToManage, ...walkedSiblings ]);
            elementsToManage = Array.from(combined);
        }
    }
    return elementsToManage;
};

var clearManagedInert = managedInertState => {
    managedInertState.forEach((hadInertBefore, element) => {
        if (!hadInertBefore) element.removeAttribute("inert");
    });
    managedInertState.clear();
};

var computeReconciledStack = ({previousStack: previousStack, openOrderCounter: openOrderCounter, getLockerContainer: getLockerContainer, captureFocusKey: captureFocusKey, onWarn: onWarn}) => {
    const checkedLockers = getAllLockers().filter(locker => locker.checked && locker.id);
    const checkedIds = new Set(checkedLockers.map(locker => locker.id));
    const previousIds = new Set(previousStack.map(entry => entry.lockerId));
    const remainingEntries = previousStack.filter(entry => checkedIds.has(entry.lockerId)).map(entry => {
        const lockerEl = checkedLockers.find(locker => locker.id === entry.lockerId) || entry.lockerEl || null;
        const containerEl = lockerEl ? getLockerContainer(lockerEl.id) : null;
        return {
            ...entry,
            lockerEl: lockerEl,
            containerEl: containerEl
        };
    });
    const openedEntries = [];
    let nextOpenOrderCounter = openOrderCounter;
    checkedLockers.forEach(locker => {
        if (previousIds.has(locker.id)) return;
        const containerEl = getLockerContainer(locker.id);
        if (!containerEl) {
            onWarn?.(`LockerManager: No container found for locker: ${locker.id}`);
            return;
        }
        const explicitFocusKey = locker.dataset.lockerOpenerFocusKey || null;
        if (explicitFocusKey) delete locker.dataset.lockerOpenerFocusKey;
        const activeFocusKey = explicitFocusKey || captureFocusKey(document.activeElement) || null;
        const entry = {
            lockerId: locker.id,
            lockerEl: locker,
            containerEl: containerEl,
            openedAt: ++nextOpenOrderCounter,
            openerFocusKey: activeFocusKey,
            source: containerEl.dataset.modalSourceType || containerEl.dataset.modalSourceContext || "locker"
        };
        remainingEntries.push(entry);
        openedEntries.push(entry);
    });
    remainingEntries.sort((a, b) => a.openedAt - b.openedAt);
    return {
        stackEntries: remainingEntries,
        openedEntries: openedEntries,
        closedEntries: previousStack.filter(entry => !remainingEntries.some(next => next.lockerId === entry.lockerId)),
        openOrderCounter: nextOpenOrderCounter
    };
};

var log = createLogger("locker-manager.js");

var LOCKER_OPENED_EVENT = "locker:opened";

var LOCKER_CLOSED_EVENT = "locker:closed";

var LOCKER_STACK_CHANGED_EVENT = "locker:stack-changed";

var LAYER_Z_INDEX_BASE = 9e3;

var UNDERLAY_RESTING_Z_INDEX = 1;

var MAX_RECOMMENDED_LAYER_DEPTH = 3;

var DEFAULT_TRANSITION_LOCK_MS = 350;

var UNDERLAY_TRANSITION_MS = 300;

var EXIT_CLEANUP_MS = 550;

var LockerManager = class {
    #elements=new Set;
    #desktopMediaQuery=null;
    #stackEntries=[];
    #openOrderCounter=0;
    #managedInertState=new Map;
    #isTransitioning=false;
    #transitionUnlockTimer=null;
    #baseUnderlayEl=null;
    #underlayTransitionTimer=null;
    #underlayTransientEl=null;
    #suppressClickHandler=null;
    #suppressTouchEndHandler=null;
    #suppressClickCleanupTimer=null;
    #exitingCleanupTimer=null;
    constructor(mainSelector = "main", sectionSelector = ".shopify-section", modalSelector = ".ajax-modal", headerSelector = "header") {
        this.selectors = {
            mainSelector: mainSelector,
            sectionSelector: sectionSelector,
            modalSelector: modalSelector,
            headerSelector: headerSelector
        };
        this.#desktopMediaQuery = window.matchMedia("(min-width: 1024px)");
        this.init();
    }
    init() {
        this.#baseUnderlayEl = ensureBaseUnderlay(this.#baseUnderlayEl, UNDERLAY_RESTING_Z_INDEX);
        this.updateElementsCache();
        this.reconcileStack();
        this.setupEventListeners();
        this.setupMediaQueryListener();
    }
    getStackSnapshot() {
        return this.#stackEntries.map(entry => entry.lockerId);
    }
    updateElementsCache() {
        const {mainSelector: mainSelector, sectionSelector: sectionSelector, modalSelector: modalSelector, headerSelector: headerSelector} = this.selectors;
        try {
            const mainElement = document.querySelector(mainSelector);
            const sectionElements = Array.from(document.querySelectorAll(sectionSelector));
            const modalElements = Array.from(document.querySelectorAll(modalSelector));
            const headerElements = Array.from(document.querySelectorAll(headerSelector));
            const inertOptIns = Array.from(document.querySelectorAll("[data-locker-inert]"));
            if (!mainElement) {
                console.warn(`LockerManager: Main element "${mainSelector}" not found.`);
                return;
            }
            this.#elements.clear();
            [ ...sectionElements, ...modalElements, ...headerElements, ...inertOptIns, mainElement ].filter(Boolean).forEach(element => this.#elements.add(element));
        } catch (error) {
            console.error("LockerManager: Error updating elements cache:", error);
        }
    }
    isHeaderElement(element) {
        const {headerSelector: headerSelector} = this.selectors;
        return isHeaderElement(element, headerSelector);
    }
    shouldMakeHeaderInert(lockerContainer = null) {
        if (this.#desktopMediaQuery.matches) return true;
        if (!lockerContainer) return false;
        const header = document.querySelector(this.selectors.headerSelector);
        return header ? !header.contains(lockerContainer) : false;
    }
    getFilteredElements(lockerContainer, mainElement) {
        const {sectionSelector: sectionSelector} = this.selectors;
        const {headerSelector: headerSelector} = this.selectors;
        return getFilteredElements({
            elements: this.#elements,
            lockerContainer: lockerContainer,
            mainElement: mainElement,
            sectionSelector: sectionSelector,
            headerSelector: headerSelector,
            shouldIncludeHeaders: this.shouldMakeHeaderInert(lockerContainer)
        });
    }
    #dispatchLockerEvent(type, detail) {
        window.dispatchEvent(new CustomEvent(type, {
            detail: detail
        }));
    }
    #setTransitionLock() {
        this.#isTransitioning = true;
        document.documentElement.dataset.lockerTransitioning = "true";
        if (this.#transitionUnlockTimer) clearTimeout(this.#transitionUnlockTimer);
        this.#transitionUnlockTimer = window.setTimeout(() => {
            this.#isTransitioning = false;
            delete document.documentElement.dataset.lockerTransitioning;
            this.#transitionUnlockTimer = null;
        }, DEFAULT_TRANSITION_LOCK_MS);
    }
    #warnOnDeepStack(depth) {
        if (depth <= MAX_RECOMMENDED_LAYER_DEPTH) return;
        console.warn(`LockerManager: Deep layer stack detected (${depth}). Consider revising UX flow before exceeding ${MAX_RECOMMENDED_LAYER_DEPTH} layers.`);
    }
    #getLockerContainer(lockerId) {
        return getLockerContainer(lockerId);
    }
    #getTopEntry() {
        return this.#stackEntries[this.#stackEntries.length - 1] || null;
    }
    #computeUnderlayZIndex() {
        return LAYER_Z_INDEX_BASE + Math.max(0, this.#stackEntries.length - 1) * 2 - 1;
    }
    #updateBaseUnderlay(isActive, {suppressCrossfade: suppressCrossfade = false} = {}) {
        const el = this.#baseUnderlayEl;
        if (!el) return;
        if (this.#underlayTransientEl) {
            clearTimeout(this.#underlayTransitionTimer);
            this.#underlayTransitionTimer = null;
            this.#baseUnderlayEl.remove();
            this.#baseUnderlayEl = this.#underlayTransientEl;
            this.#underlayTransientEl = null;
        }
        const topEntry = this.#getTopEntry();
        const topContainer = topEntry ? this.#getLockerContainer(topEntry.lockerId) : null;
        const header = document.querySelector(this.selectors.headerSelector);
        const shouldElevate = Boolean(topContainer) && (!header || !header.contains(topContainer));
        if (!isActive) {
            clearTimeout(this.#underlayTransitionTimer);
            this.#underlayTransitionTimer = null;
            el.dataset.active = "false";
            el.style.zIndex = String(UNDERLAY_RESTING_Z_INDEX);
            return;
        }
        if (!shouldElevate) {
            clearTimeout(this.#underlayTransitionTimer);
            this.#underlayTransitionTimer = null;
            el.dataset.active = "true";
            el.style.zIndex = String(UNDERLAY_RESTING_Z_INDEX);
            return;
        }
        const newZIndex = this.#computeUnderlayZIndex();
        const currentZIndex = parseInt(el.style.zIndex, 10);
        const isCurrentlyActive = el.dataset.active === "true";
        if (!suppressCrossfade && isCurrentlyActive && currentZIndex !== newZIndex) this.#crossfadeUnderlayToZIndex(newZIndex); else {
            el.style.zIndex = String(newZIndex);
            el.dataset.active = "true";
        }
    }
    #crossfadeUnderlayToZIndex(newZIndex) {
        const oldEl = this.#baseUnderlayEl;
        const clone = document.createElement("div");
        clone.setAttribute("data-locker-base-underlay", "");
        clone.className = "locker-base-underlay";
        clone.style.zIndex = String(newZIndex);
        clone.dataset.active = "false";
        document.body.appendChild(clone);
        oldEl.dataset.active = "false";
        clone.offsetHeight;
        clone.dataset.active = "true";
        this.#underlayTransientEl = clone;
        clearTimeout(this.#underlayTransitionTimer);
        this.#underlayTransitionTimer = window.setTimeout(() => {
            oldEl.remove();
            this.#baseUnderlayEl = clone;
            this.#underlayTransientEl = null;
            this.#underlayTransitionTimer = null;
        }, UNDERLAY_TRANSITION_MS);
    }
    #suppressFollowingClick() {
        this.#clearSuppressClickHandler();
        this.#suppressTouchEndHandler = touchEvent => {
            if (!touchEvent.isTrusted) return;
            touchEvent.preventDefault();
            document.removeEventListener("touchend", this.#suppressTouchEndHandler, {
                capture: true
            });
            this.#suppressTouchEndHandler = null;
        };
        document.addEventListener("touchend", this.#suppressTouchEndHandler, {
            capture: true,
            passive: false
        });
        this.#suppressClickHandler = clickEvent => {
            if (!clickEvent.isTrusted) return;
            clickEvent.preventDefault();
            clickEvent.stopPropagation();
            this.#clearSuppressClickHandler();
        };
        document.addEventListener("click", this.#suppressClickHandler, true);
        this.#suppressClickCleanupTimer = window.setTimeout(() => {
            this.#clearSuppressClickHandler();
        }, DEFAULT_TRANSITION_LOCK_MS);
    }
    #clearSuppressClickHandler() {
        if (this.#suppressClickHandler) {
            document.removeEventListener("click", this.#suppressClickHandler, true);
            this.#suppressClickHandler = null;
        }
        if (this.#suppressTouchEndHandler) {
            document.removeEventListener("touchend", this.#suppressTouchEndHandler, {
                capture: true
            });
            this.#suppressTouchEndHandler = null;
        }
        if (this.#suppressClickCleanupTimer) {
            clearTimeout(this.#suppressClickCleanupTimer);
            this.#suppressClickCleanupTimer = null;
        }
    }
    #handleOutsidePointerDown=event => {
        const topEntry = this.#getTopEntry();
        if (!topEntry?.lockerEl?.checked || !topEntry.containerEl) return;
        if (this.#isTransitioning) return;
        if (event.pointerType === "mouse" && event.button !== 0) return;
        if ((topEntry.containerEl.querySelector("[data-drawer]") || topEntry.containerEl).contains(event.target)) return;
        this.#suppressFollowingClick();
        topEntry.lockerEl.click();
    };
    #clearManagedInert() {
        clearManagedInert(this.#managedInertState);
    }
    #applyManagedInert(topEntry) {
        this.#clearManagedInert();
        if (!topEntry?.containerEl) return;
        const mainElement = document.querySelector(this.selectors.mainSelector);
        if (!mainElement) return;
        this.getFilteredElements(topEntry.containerEl, mainElement).forEach(element => {
            if (!this.#managedInertState.has(element)) this.#managedInertState.set(element, element.hasAttribute("inert"));
            element.setAttribute("inert", "");
        });
    }
    #applyContainerStates() {
        applyContainerStates({
            stackEntries: this.#stackEntries,
            layerZIndexBase: LAYER_Z_INDEX_BASE,
            getLockerContainer: lockerId => this.#getLockerContainer(lockerId)
        });
    }
    #syncContainerAriaHidden() {
        getAllLockers().forEach(locker => {
            if (!locker.id) return;
            const container = this.#getLockerContainer(locker.id);
            if (!container) return;
            const isActive = this.#stackEntries.some(entry => entry.lockerId === locker.id);
            container.setAttribute("aria-hidden", isActive ? "false" : "true");
        });
    }
    #restoreFocusFromEntry(entry) {
        if (!entry?.openerFocusKey) return;
        if (document.documentElement.dataset.lockerSuppressFocusRestore === "true") return;
        requestAnimationFrame(() => {
            const target = document.querySelector(entry.openerFocusKey);
            if (isFocusable(target)) {
                target.focus();
                return;
            }
            const fallbackTarget = this.#getTopEntry()?.containerEl?.querySelector("[data-close], label[for], button, [href], input") || null;
            if (isFocusable(fallbackTarget)) fallbackTarget.focus();
        });
    }
    reconcileStack({changedLocker: changedLocker = null} = {}) {
        this.updateElementsCache();
        const previousStack = [ ...this.#stackEntries ];
        const {stackEntries: stackEntries, openedEntries: openedEntries, closedEntries: closedEntries, openOrderCounter: openOrderCounter} = computeReconciledStack({
            previousStack: previousStack,
            openOrderCounter: this.#openOrderCounter,
            getLockerContainer: lockerId => this.#getLockerContainer(lockerId),
            captureFocusKey: captureFocusKey,
            onWarn: message => console.warn(message)
        });
        this.#stackEntries = stackEntries;
        this.#openOrderCounter = openOrderCounter;
        this.#warnOnDeepStack(this.#stackEntries.length);
        this.#applyContainerStates();
        this.#scheduleExitingCleanup();
        this.#applyManagedInert(this.#getTopEntry());
        this.#syncContainerAriaHidden();
        openedEntries.forEach(entry => {
            const index = this.#stackEntries.findIndex(item => item.lockerId === entry.lockerId);
            this.#dispatchLockerEvent(LOCKER_OPENED_EVENT, {
                lockerId: entry.lockerId,
                index: index,
                depth: this.#stackEntries.length,
                source: entry.source,
                openerFocusKey: entry.openerFocusKey
            });
        });
        closedEntries.forEach(entry => {
            const wasTop = previousStack[previousStack.length - 1]?.lockerId === entry.lockerId;
            this.#dispatchLockerEvent(LOCKER_CLOSED_EVENT, {
                lockerId: entry.lockerId,
                depthBeforeClose: previousStack.length,
                source: entry.source || "locker",
                wasTop: wasTop
            });
            if (wasTop) this.#restoreFocusFromEntry(entry);
        });
        const topLockerId = this.#getTopEntry()?.lockerId || null;
        this.#dispatchLockerEvent(LOCKER_STACK_CHANGED_EVENT, {
            stack: this.#stackEntries.map(entry => entry.lockerId),
            topLockerId: topLockerId,
            depth: this.#stackEntries.length,
            changedLockerId: changedLocker?.id || null,
            isTransitioning: this.#isTransitioning
        });
        const suppressCrossfade = (changedLocker?.id ? this.#getLockerContainer(changedLocker.id) : null)?.dataset.lockerUnderlay === "skip";
        this.#updateBaseUnderlay(this.#stackEntries.length > 0, {
            suppressCrossfade: suppressCrossfade
        });
    }
    #scheduleExitingCleanup() {
        if (this.#exitingCleanupTimer) clearTimeout(this.#exitingCleanupTimer);
        this.#exitingCleanupTimer = window.setTimeout(() => {
            this.#exitingCleanupTimer = null;
            this.#cleanupExitingLayers();
        }, EXIT_CLEANUP_MS);
    }
    #cleanupExitingLayers() {
        getAllLockers().forEach(locker => {
            if (!locker.id) return;
            const container = this.#getLockerContainer(locker.id);
            if (!container) return;
            if (container.dataset.layerExiting !== "true") return;
            if (locker.checked) {
                delete container.dataset.layerExiting;
                return;
            }
            container.style.removeProperty("z-index");
            delete container.dataset.layerExiting;
        });
    }
    #handlePageShow=event => {
        const [navigationEntry] = performance.getEntriesByType("navigation");
        if (!event.persisted && navigationEntry?.type !== "back_forward") return;
        getAllLockers().forEach(locker => {
            if (!locker.checked) return;
            locker.checked = false;
            locker.dispatchEvent(new Event("change", {
                bubbles: true
            }));
        });
    };
    #handleMediaQueryChange=() => {
        if (this.#stackEntries.length === 0) return;
        this.#applyManagedInert(this.#getTopEntry());
    };
    setupMediaQueryListener() {
        this.#desktopMediaQuery.addEventListener("change", this.#handleMediaQueryChange);
    }
    setupEventListeners() {
        document.addEventListener("pointerdown", this.#handleOutsidePointerDown, true);
        window.addEventListener("pageshow", this.#handlePageShow);
        document.addEventListener("change", event => {
            const locker = event.target?.closest?.("[data-locker]");
            if (!locker) return;
            log("lifecycle", "locker change", {
                id: locker.id,
                checked: locker.checked
            });
            this.#setTransitionLock();
            this.reconcileStack({
                changedLocker: locker
            });
        });
        window.addEventListener("locker_add", event => {
            const newLockerId = event.detail;
            if (!newLockerId) {
                console.warn('LockerManager: "locker_add" event triggered without locker ID in detail.');
                return;
            }
            const newLocker = document.querySelector(`#${escapeAttributeValue(newLockerId)}`);
            if (!newLocker) {
                console.warn(`LockerManager: Could not find new locker with ID: ${newLockerId}`);
                return;
            }
            this.reconcileStack({
                changedLocker: newLocker
            });
        });
    }
    destroy() {
        if (this.#desktopMediaQuery) this.#desktopMediaQuery.removeEventListener("change", this.#handleMediaQueryChange);
        document.removeEventListener("pointerdown", this.#handleOutsidePointerDown, true);
        window.removeEventListener("pageshow", this.#handlePageShow);
        if (this.#transitionUnlockTimer) {
            clearTimeout(this.#transitionUnlockTimer);
            this.#transitionUnlockTimer = null;
        }
        if (this.#underlayTransitionTimer) {
            clearTimeout(this.#underlayTransitionTimer);
            this.#underlayTransitionTimer = null;
        }
        if (this.#exitingCleanupTimer) {
            clearTimeout(this.#exitingCleanupTimer);
            this.#exitingCleanupTimer = null;
        }
        if (this.#underlayTransientEl) {
            this.#underlayTransientEl.remove();
            this.#underlayTransientEl = null;
        }
        this.#clearSuppressClickHandler();
        delete document.documentElement.dataset.lockerTransitioning;
        this.#updateBaseUnderlay(false);
        this.#clearManagedInert();
        this.#elements.clear();
        this.#stackEntries = [];
    }
};

var ARIA_INIT_FLAG = "data-locker-aria-initialised";

var syncLockerLabels = locker => {
    if (!locker?.id) return;
    const escapedId = escapeAttributeValue(locker.id);
    const expanded = locker.checked ? "true" : "false";
    document.querySelectorAll(`label[for="${escapedId}"], [data-locker-open="${escapedId}"], [aria-controls="${escapedId}"]`).forEach(trigger => trigger.setAttribute("aria-expanded", expanded));
};

var initLockerLabels = locker => {
    if (!locker || locker.hasAttribute("data-locker-aria-initialised")) return;
    locker.setAttribute("data-locker-aria-initialised", "true");
    syncLockerLabels(locker);
};

var collectAddedNodes = node => ({
    lockers: node.matches?.("[data-locker]") ? [ node, ...Array.from(node.querySelectorAll("[data-locker]")) ] : Array.from(node.querySelectorAll("[data-locker]")),
    labels: node.matches?.("label[for]") ? [ node, ...Array.from(node.querySelectorAll("label[for]")) ] : Array.from(node.querySelectorAll("label[for]")),
    triggers: node.matches?.("[data-locker-open], [aria-controls]") ? [ node, ...Array.from(node.querySelectorAll("[data-locker-open], [aria-controls]")) ] : Array.from(node.querySelectorAll("[data-locker-open], [aria-controls]"))
});

var handleChange = event => {
    const locker = event.target?.closest?.("[data-locker]");
    if (!locker) return;
    syncLockerLabels(locker);
};

var initLockerAria = () => {
    if (document.body.hasAttribute(ARIA_INIT_FLAG)) return;
    document.body.setAttribute(ARIA_INIT_FLAG, "true");
    getAllLockers().forEach(initLockerLabels);
    document.addEventListener("change", handleChange);
    new MutationObserver(mutations => {
        mutations.forEach(mutation => {
            mutation.addedNodes.forEach(node => {
                if (node.nodeType !== Node.ELEMENT_NODE) return;
                const {lockers: lockers, labels: labels, triggers: triggers} = collectAddedNodes(node);
                lockers.forEach(locker => {
                    initLockerLabels(locker);
                });
                labels.forEach(label => {
                    const target = document.getElementById(label.getAttribute("for") || "");
                    if (target?.hasAttribute("data-locker")) syncLockerLabels(target);
                });
                triggers.forEach(trigger => {
                    const targetId = trigger.getAttribute("data-locker-open") || trigger.getAttribute("aria-controls") || "";
                    const target = document.getElementById(targetId);
                    if (target?.hasAttribute("data-locker")) syncLockerLabels(target);
                });
            });
        });
    }).observe(document.body, {
        childList: true,
        subtree: true
    });
};

var TRIGGERS_INIT_FLAG = "lockerTriggersInitialised";

var setLockerChecked = (lockerId, checked) => {
    const locker = document.getElementById(lockerId);
    if (!locker) return;
    locker.checked = checked;
    locker.dispatchEvent(new Event("change", {
        bubbles: true
    }));
};

var handleTriggerClick = event => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const closer = target.closest("[data-locker-close]");
    if (closer) {
        setLockerChecked(closer.getAttribute("data-locker-close") || "", false);
        return;
    }
    const opener = target.closest("[data-locker-open]");
    if (opener) setLockerChecked(opener.getAttribute("data-locker-open") || "", true);
};

var initLockerTriggers = () => {
    window.MBF = window.MBF || {};
    if (window.MBF[TRIGGERS_INIT_FLAG]) return;
    window.MBF[TRIGGERS_INIT_FLAG] = true;
    document.addEventListener("click", handleTriggerClick);
};

function initLockerSystem() {
    window.LockerManager = new LockerManager;
    initLockerAria();
    initLockerTriggers();
}

function initLockerEscape() {
    document.addEventListener("keydown", event => {
        if (event.key !== "Escape") return;
        const topLockerId = document.querySelector('[data-locker-container][data-layer-top="true"]')?.getAttribute("data-locker-container") || null;
        const topLocker = topLockerId ? document.getElementById(topLockerId) : null;
        if (topLocker?.checked) {
            topLocker.click();
            return;
        }
        const fallbackOpenLocker = document.querySelector("[data-locker]:checked");
        if (fallbackOpenLocker) fallbackOpenLocker.click();
    }, {
        passive: true
    });
}

function initScrollLock() {
    const updateScrollLockState = () => {
        const hasOpenLocker = Boolean(document.querySelector("[data-locker]:checked"));
        document.documentElement.classList.toggle("lock-scroll", hasOpenLocker);
    };
    const setupLocker = locker => {
        locker.addEventListener("change", updateScrollLockState);
    };
    document.querySelectorAll("[data-locker]").forEach(setupLocker);
    window.addEventListener("locker_add", event => {
        const newLockerId = event.detail;
        if (!newLockerId) return;
        const newLocker = document.querySelector(`#${CSS.escape(newLockerId)}`);
        if (!newLocker) return;
        setupLocker(newLocker);
        updateScrollLockState();
    });
    updateScrollLockState();
}

function handleSubscriptionError() {
    const url = window.location.href;
    if (!url.includes("form_type=customer")) return;
    const id = url.split("#").pop() || "footer";
    const form = document.querySelector(`#${CSS.escape(id)}`) || document.querySelector('footer[action^="/contact"]');
    if (!form) return;
    const input = form.querySelector('[type="email"]');
    if (!input || input.value.length === 0) return;
    const errorMsg = document.createElement("p");
    errorMsg.classList.add("mt-sm", "text-terracotta");
    errorMsg.innerText = window.MBF?.strings?.newsletter?.existing || "You are already subscribed.";
    form.appendChild(errorMsg);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "newsletter_signup",
        form_action: "submit-failure",
        error_id: window.MBF?.strings?.newsletter?.existing
    });
}

function trackRecentlyViewed() {
    const key = "recentlyViewed";
    let recentlyViewed = [];
    try {
        recentlyViewed = JSON.parse(localStorage.getItem(key)) || [];
    } catch {}
    const productId = location.href.match(/\/products\/([^\?#]+)/)?.[1];
    if (productId && !recentlyViewed.includes(productId)) {
        const updatedList = [ productId, ...recentlyViewed ].slice(0, 8);
        localStorage.setItem(key, JSON.stringify(updatedList));
        window.Shopify = {
            ...window.Shopify,
            recentlyViewed: updatedList
        };
    }
}

function updateVisualViewport() {
    const root = document.documentElement;
    const siteHeader = (document.querySelector("[data-header]") || document.querySelector("header"))?.querySelector("site-header");
    const announcementBar = document.querySelector("[data-announcement]") || document.querySelector(".section-announcement");
    const headerHeight = Math.round(siteHeader?.getBoundingClientRect().height) || 0;
    const announcementRect = announcementBar?.getBoundingClientRect();
    const announcementHeight = Math.round(announcementRect?.height) || 0;
    const announcementContribution = Boolean(announcementRect) && announcementRect.top >= 0 ? announcementHeight : 0;
    root.style.setProperty("--visual-viewport", `${window.visualViewport?.height || window.innerHeight}px`);
    root.style.setProperty("--header-height", `${headerHeight}px`);
    root.style.setProperty("--announcement-height", `${announcementHeight}px`);
    root.style.setProperty("--header-full-height", `${Math.round((headerHeight || 0) + announcementContribution)}px`);
}

function initViewportVars() {
    window.addEventListener("layout:change", () => updateVisualViewport());
    window.dispatchEvent(new CustomEvent("layout:change"));
    const mediaQuery1024 = window.matchMedia("(max-width: 1024px)");
    const mediaQuery600 = window.matchMedia("(max-width: 600px)");
    const handleViewportChange = () => updateVisualViewport();
    updateVisualViewport();
    mediaQuery1024.addEventListener("change", handleViewportChange);
    mediaQuery600.addEventListener("change", handleViewportChange);
}

function initBodyUtils() {
    initLockerSystem();
    initLockerEscape();
    initLabelKeyboardAccessibility();
    initButtonRoleAccessibility();
    initScrollLock();
    trackRecentlyViewed();
    if (window.Geo) checkLocation();
    initViewportVars();
    handleSubscriptionError();
    exposeAccessibilityCleanup();
}

(async () => {
    const log = createLogger("main");
    try {
        log("lifecycle", "Initializing core app modules");
        initModalOrchestrator();
        log("lifecycle", "Modal orchestrator initialized");
        initLoadingSpinnerPositioning();
        log("lifecycle", "Loading spinner positioning initialized");
        initCart();
        log("lifecycle", "Cart module initialized");
        initCartUI();
        log("lifecycle", "Cart UI module initialized");
        initCartAnalytics();
        log("lifecycle", "Cart analytics module initialized");
        initBodyUtils();
        log("lifecycle", "Body utilities initialized");
        initAppWidgets();
        log("lifecycle", "App widgets manager initialized");
        if (window.MBF?.settings?.enableBackInStock) {
            initBis();
            log("lifecycle", "BIS module initialized");
        }
    } catch (coreError) {
        log("errors", "Critical error during core app initialization", serializeError(coreError));
        console.error("Critical error initializing core app modules:", coreError);
    }
})();